<template>
  <div class="space">
    <div class="center">
      <div class="center-top">

        <div class="return" @click="repage"><img src="@/assets/images/return.png" alt="">返回上一步</div>
        <div class="step">
          <div :class="step == 0 ? 'item itemed' : 'item'">剧本创意</div>
          <div class="jt"><img v-show="step == 0" src="@/assets/images/jtl.png" alt=""><img v-show="step != 0"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 1 ? 'item itemed' : 'item'">剧情梗概</div>
          <div class="jt"><img v-show="step == 1" src="@/assets/images/jtl.png" alt=""><img v-show="step != 1"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 2 ? 'item itemed' : 'item'">分段脚本</div>
          <div class="jt"><img v-show="step == 2" src="@/assets/images/jtl.png" alt=""><img v-show="step != 2"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 3 ? 'item itemed' : 'item'">角色设计</div>
          <div class="jt"><img v-show="step == 3" src="@/assets/images/jtl.png" alt=""><img v-show="step != 3"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 4 ? 'item itemed' : 'item'">生成分镜</div>
        </div>
      </div>
      <div class="center-body">
        <div class="stepbox step4">
          <div class="st4_l">
            <div class="loading" v-if="loading">
              <div class="lod1"><a-spin size="large" />
                <div class="js">正在生成角色..，约耗时25秒左右，请勿离开页面</div>
              </div>
            </div>
            <div v-else>
              <div class="top">角色/产品 <span @click="refreshAll"><img src="@/assets/images/refresh.png"
                    alt="">批量重新生成</span></div>
              <div class="s_body custom-scrollbar">
                <div class="item" v-for="(item, index) in characters" :key="index">
                  <div class="it1">
                    <!-- <div class="k" v-if="!isscore">
                    <img src="@/assets/images/ds.png" alt="">
                    <div class="tip">积分不足</div>
                  </div> -->
                    <el-tooltip class="refresh" effect="dark" content="重新生成" placement="top">
                      <img @click="recreate(item, index)" src="@/assets/images/refresh2.png" alt="">
                    </el-tooltip>
                    <div class="loading" v-show="item.restart">
                      <div class="load1"><a-spin size="large" />
                        <div class="js">正在重新生成</div>
                      </div>
                    </div>
                    <div class="img" v-show="!item.restart">
                      <div class="download" @click="downloadImage(item.image_url)"><img src="@/assets/images/load.png"
                          alt=""></div>
                      <img :src="item.image_url" alt="">
                    </div>
                  </div>
                  <div class="it2">
                    <span>名称：</span><input type="text" v-model="item.character_name" placeholder="">
                  </div>
                  <div class="it3">
                    <span>定位：</span><input v-model="item.character_position" placeholder="" type="text">
                  </div>
                  <div class="it4">
                    <span>外观：</span><textarea v-model="item.character_appearance" name="" id="" cols="30"
                      rows="10"></textarea>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="st4_r">
            <div class="sr1">
              <div class="top">选择模型</div>
              <div class="bottom">
                <el-select v-model="module_type" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="sr1">
              <div class="top">视频风格</div>
              <div class="bottom">
                <el-select v-model="sp_type" placeholder="请选择">
                  <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="sr1">
              <div class="top">视频风格</div>
              <div class="bottom">
                <textarea type="text" v-model="sp_style" :disabled="sp_type !== '自定义'"
                  placeholder="风格选择自定义时可输入"></textarea>
              </div>
            </div>
            <div class="sr2" @click="next">
              生成分镜
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: '',
  data () {
    return {
      id: 0,
      step: 3,
      loading: true,

      characters: [],
      options: [{
        value: '可灵',
        label: '可灵'
      },
        //  {
        //   value: '即梦',
        //   label: '即梦'
        // }
      ],
      module_type: '可灵',
      options2: [{
        value: '电影风格',
        label: '电影风格'
      }, {
        value: '二维动画',
        label: '二维动画'
      }, {
        value: '广告风格',
        label: '广告风格'
      }, {
        value: 'CG风格',
        label: 'CG风格'
      }, {
        value: '黑白线稿',
        label: '黑白线稿'
      }, {
        value: '自定义',
        label: '自定义'
      }],
      sp_type: '电影风格',
      sp_style: '',
      isscore: true
    }
  },
  async created () {
    this.id = this.$route.query.id
    console.log(JSON.parse(sessionStorage.getItem('index4')));
    if (this.$route.query.summary_id) {
      let res = await this.$http('api.getImgHis', {
        script_segment_id: this.$route.query.summary_id    //剧情梗概ID
      })
      if (res.data.character_designs[0].image_url == '') {
        this.createjs(res.data.character_designs)
      } else {
        this.loading = false
        res.data.character_designs.map(item => {
          item.restart = false
        });
        this.characters = res.data.character_designs

      }
    }
  },
  mounted () {
    this.$bus.$emit('menu-active', false) // 关闭激活状态
  },
  methods: {
    ...mapActions("user", ["getUserInfo"]),
    
    // 下载
    downloadImage (imgUrl) {
      const fileName = "my-image";
      const link = document.createElement("a");
      // 设置下载属性（文件名）
      link.download = fileName;
      // 设置图片 URL（处理跨域需特殊处理，见注意事项）
      link.href = imgUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async createjs (data) {
      this.loading = true
      const promises = data.map(async (item) => {
        const res = await this.getJsimg(item.character_name, item.character_position, item.character_appearance);
        this.getUserInfo()
        // 返回处理后的新对象（避免直接修改原数组元素）
        return {
          ...item,
          restart: false,
          character_image_id: res.character_image_id,
          image_url: res.image_url
        };
      });

      // 等待所有异步操作完成，获取所有结果
      const arr = await Promise.all(promises);

      // 所有结果返回后再更新
      this.characters = arr;
      this.loading = false


    },
    async getJsimg (character_name, character_position, character_appearance) {
      character_appearance = character_appearance.replace(/[@#]/g, "")
      let data = {
        script_segment_id: this.$route.query.summary_id,
        character_name,
        character_position,
        style: '写实风',
        character_appearance
      }
      const res = await this.$http('api.createJsImg', data)
      return res.data
    },
    // 重新生成一张
    async recreate (item, index) {
      this.characters[index].restart = true
      let data = {
        character_image_id: item.character_image_id,
        character_name: item.character_name,
        character_position: item.character_position,
        style: '写实风',
        character_appearance: item.character_appearance
      }
      const res = await this.$http('api.reJsImg', data)
      this.getUserInfo();
      this.characters[index].image_url = res.data.image_url
      this.characters[index].restart = false
    },
    // 全部重新生成
    async refreshAll () {
      this.loading = true
      let data = JSON.parse(JSON.stringify(this.characters))
      const promises = data.map(async (item) => {
        const res = await this.$http('api.reJsImg', item)
        return {
          ...res.data, // 扩展接口返回的核心数据
          restart: false, // 新增/覆盖 restart 字段
        };
      });

      // 等待所有异步操作完成，获取所有结果
      this.characters = await Promise.all(promises);
      this.loading = false
    },
    // 返回上一页
    repage () {
      this.$router.go(-1)
    },
    next(){
      this.$router.push(`/project2/project2_5?id=${this.id}&summary_id=${this.$route.query.summary_id}&random=${Math.random()}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.space {
  width: 100%;
  height: 100%;
  display: flex;

  .center {
    flex: 1;
    // padding: 20px;
    height: calc(100vh - 80px);

    .center-top {
      margin-top: 20px;
      height: 44px;
      position: relative;

      .return,
      .next {
        position: absolute;
        width: 134px;
        text-align: center;
        height: 36px;
        line-height: 36px;
        top: 50%;
        transform: translateY(-50%);
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #DDDDDD;
        cursor: pointer;

        img {
          width: 20px;
          margin-right: 4px;
          transform: translateY(-2px);
        }
      }

      .return {
        left: 20px;
      }

      .next {
        right: 20px;
      }

      .step {
        margin: 0 auto;
        width: 620px;
        height: 44px;
        line-height: 44px;
        background: #FFFFFF;
        box-shadow: 2px 2px 12px 0px rgba(97, 92, 92, 0.2);
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #046DFA;
        display: flex;
        justify-content: center;

        .item {
          font-size: 18px;
          color: #595959;
        }

        .itemed {
          font-weight: bold;
          color: #046DFA;
        }

        .jt {
          margin: 0 16px;

          img {
            width: 16px;
          }
        }
      }
    }

    .center-body {
      margin: 0 auto;
      width: 100%;
      margin-top: 20px;
      height: calc(100vh - 180px);
      overflow: hidden;

      .stepbox {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

      }

      .step4 {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        .st4_l {
          width: 79%;
          height: 100%;
          border-radius: 16px;
          background-color: rgb(241, 241, 241);
          padding: 20px;

          .loading {
            width: 100%;

            .lod1 {
              width: 100%;
              text-align: center;
              margin-top: 200px;

              .js {
                margin-top: 20px;
              }
            }
          }

          .top {
            height: 30px;
            font-size: 24px;
            line-height: 30px;
            display: flex;

            span {
              cursor: pointer;
              margin-left: 20px;
              font-size: 16px;

              img {
                margin-right: 4px;
                width: 16px;
                transform: translateY(-2px);
              }
            }
          }

          .s_body {
            height: 600px;
            overflow: auto;
            width: 100%;
            margin-top: 20px;
            display: flex;
            flex-wrap: wrap;

            .item {
              margin-bottom: 20px;
              margin-left: 20px;
              width: 240px;
              padding: 10px;
              height: 500px;
              border-radius: 8px;
              border: 1px solid #d1d1d1;

              .it1 {
                width: 100%;
                height: 280px;
                overflow: hidden;
                border-radius: 8px;
                position: relative;

                .k {
                  background-color: #d1cfcf;
                  width: 100%;
                  height: 100%;
                  text-align: center;

                  img {
                    width: 50px;
                    margin-top: 80px;
                  }

                  .tip {
                    width: 100%;
                    text-align: center;
                    font-size: 14px;
                    margin-top: 10px;
                    color: #7c7c7c;
                  }
                }

                .refresh {
                  position: absolute;
                  z-index: 2;
                  right: 10px;
                  width: 20px;
                  top: 20px;
                  cursor: pointer;
                  display: none;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }

                .loading {
                  overflow: hidden;
                  width: 100%;
                  height: 100%;
                  background-color: #ececec;

                  .load1 {
                    width: 100%;
                    text-align: center;
                    margin-top: 100px;

                    .js {
                      margin-top: 20px;
                    }
                  }
                }

                .img {
                  width: 100%;
                  height: 100%;
                  position: relative;
                  background-color: #e2dfdf;

                  .download {
                    display: none;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    position: absolute;
                    z-index: 2;
                    width: 40px;
                    height: 40px;
                    text-align: center;
                    background-color: #313131bd;
                    border-radius: 4px;
                    cursor: pointer;

                    img {
                      margin-left: 8px;
                      margin-top: 1px;
                      width: 24px;
                      height: 24px;
                    }
                  }

                  img {
                    position: absolute;
                    width: 100%;
                    top: 50%;
                    left: 0;
                    transform: translateY(-50%);
                  }
                }

                .img:hover .download {
                  display: block;
                }
              }

              .it1:hover .refresh {
                display: block;
              }

              .it2,
              .it3 {
                margin-top: 4px;
                width: 100%;
                height: 30px;
                line-height: 30px;
                position: relative;
                font-size: 14px;

                input {
                  padding-left: 40px;
                  width: 100%;
                  height: 100%;
                  border: 1px solid #b9b7b7;
                  border-radius: 4px;
                }

                span {
                  position: absolute;
                  height: 30px;
                  line-height: 30px;
                  width: 50px;
                  font-size: 14px;
                  left: 4px;
                }

                img {}


              }

              .it4 {
                font-size: 14px;

                span {
                  display: block;
                  margin: 4px 0;
                  font-size: 14px;
                }

                textarea {

                  resize: none;
                  width: 100%;
                  height: 100px;
                  border: 1px solid #b9b7b7;
                  border-radius: 4px;
                  padding: 10px;
                }
              }
            }
          }
        }

        .st4_r {
          padding: 10px;
          width: 19%;
          height: 100%;
          border-radius: 16px;
          background-color: rgb(241, 241, 241);

          .sr1 {
            width: 100%;
            margin-bottom: 20px;

            .top {
              margin-bottom: 10px;
            }

            .bottom {
              width: 100%;

              >div {
                width: 100%;
              }

              textarea {
                padding: 10px;
                width: 100%;
                height: 80px;
                border: 1px solid #e2e2e2;
                border-radius: 4px;
                font-size: 14px;
                resize: none;
              }

              textarea:hover {
                border: 1px solid #1f70da;
              }
            }
          }
          .sr2{
            cursor: pointer;
            margin: 0 auto;
            margin-top: 300px;
            color: white;
            width: 80%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: linear-gradient(90deg, #66AFFF 0%, #046CF3 100%);
            border-radius: 8px;
          }
        }
      }
    }
  }
}
</style>
